// extracted by mini-css-extract-plugin
export default {"bannerStyle":"PocetnaBaner_bannerStyle__Rk4Fh","videoStyle":"PocetnaBaner_videoStyle__xO8Bi"};